(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partial_announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if($('.marquee').length) {
    Marquee3k.init({
      selector: 'marquee',
    });
  }
  const announcementBar = document.querySelector('.announcement-bar-section');
  if (announcementBar) {
    const body = document.querySelector('body');
    body.classList.add('has-announcement-bar');
    const announcementBarHeight = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partial_related-products"]) return;
  try {
    
  window.onload = () => {
    const productRecommendationsSection = document.querySelector('.related-products-container');
    if (!productRecommendationsSection) return;

    const url = productRecommendationsSection.dataset.url;
    if (!url) return;

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.related-products-container');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(e => {
      console.error(e);
    });
  };

  } catch(e) { console.error(e); }
})();
})();
